/* Accessible hot/cold mode switcher with Shopify Theme Editor support. */
(function () {
  function initSwitcher(root) {
    if (root.dataset.lvModeReady === 'true') return;
    root.dataset.lvModeReady = 'true';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-lv-mode-tab]'));

    function activate(tab, moveFocus) {
      if (!tab) return;
      var mode = tab.getAttribute('data-lv-mode-tab');
      root.setAttribute('data-lv-mode', mode);
      tabs.forEach(function (item) {
        var active = item === tab;
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.setAttribute('tabindex', active ? '0' : '-1');
      });
      if (moveFocus) tab.focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activate(tab, false); });
      tab.addEventListener('keydown', function (event) {
        var nextIndex;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === undefined) return;
        event.preventDefault();
        activate(tabs[nextIndex], true);
      });
    });

    var initialMode = root.getAttribute('data-lv-mode');
    activate(tabs.find(function (tab) {
      return tab.getAttribute('data-lv-mode-tab') === initialMode;
    }) || tabs[0], false);
  }

  function init(scope) {
    if (scope.matches && scope.matches('[data-lv-mode-switcher]')) initSwitcher(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-lv-mode-switcher]').forEach(initSwitcher);
  }
  function start() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
